export const openGameInHybrid888App = (url: string, closebut: boolean) => {
  window.webkit?.messageHandlers?.cbCallBackHandlerCGP?.postMessage(
    JSON.stringify({
      Func: 'OpenSecondWebView',
      url,
      closebut: closebut.toString(), // Game should be closed using "Exit Game" button from navbar to close it
    })
  );
};
